(function () {
  function pad(value) { return String(value).padStart(2, '0'); }

  function startCountdown(element) {
    if (element.dataset.countdownReady === 'true') return;
    element.dataset.countdownReady = 'true';

    var endTime = Date.parse(element.dataset.endTime || '');
    var ended = element.querySelector('[data-countdown-ended]');
    var units = element.querySelector('.giveaway-countdown__units');
    var label = element.querySelector('.giveaway-countdown__label');
    var daysUnit = element.querySelector('[data-countdown-day-unit]');

    function showEnded(message) {
      if (units) units.hidden = true;
      if (label) label.hidden = true;
      if (ended) {
        ended.textContent = message;
        ended.hidden = false;
      }
    }

    function tick() {
      var difference = endTime - Date.now();
      if (Number.isNaN(endTime)) {
        showEnded('Countdown unavailable.');
        return;
      }
      if (difference <= 0) {
        showEnded(element.dataset.endedMessage || 'This giveaway has ended.');
        return;
      }

      var values = {
        days: Math.floor(difference / 86400000),
        hours: Math.floor((difference % 86400000) / 3600000),
        minutes: Math.floor((difference % 3600000) / 60000),
        seconds: Math.floor((difference % 60000) / 1000)
      };

      Object.keys(values).forEach(function (unit) {
        var output = element.querySelector('[data-countdown-' + unit + ']');
        if (output) output.textContent = pad(values[unit]);
      });
      if (daysUnit) daysUnit.style.display = values.days === 0 ? 'none' : '';
      window.setTimeout(tick, 1000);
    }

    tick();
  }

  function initialize() {
    document.querySelectorAll('[data-giveaway-countdown]').forEach(startCountdown);
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState !== 'loading') initialize();
})();
